import React from 'react'
import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react'
import { StockData } from '../types'
import PriceDisplay from './PriceDisplay'
import RefreshButton from './RefreshButton'

interface StockHeaderProps {
  borderColor: string
  cardBg: string
  data: StockData
  isRefreshing: boolean
  onRefresh: () => void
}

const StockHeader: React.FC<StockHeaderProps> = ({
  borderColor,
  cardBg,
  data,
  isRefreshing,
  onRefresh
}) => (
  <Box
    bg={cardBg}
    borderRadius="lg"
    borderWidth="1px"
    borderColor={borderColor}
    boxShadow="md"
    mb={4}
    p={4}
  >
    <Flex
      align={{ base: 'flex-start', md: 'center' }}
      direction={{ base: 'column', md: 'row' }}
      justify="space-between"
      mb={4}
    >
      <Flex align="center" mb={{ base: 4, md: 0 }}>
        {data.logo && (
          <Image
            alt={`${data.symbol} logo`}
            borderRadius="full"
            boxSize="50px"
            mr={4}
            src={data.logo}
          />
        )}
        
        <Box>
          <Heading as="h2" size="md">
            {data.companyName}
          </Heading>
          <Text color="gray.500" fontSize="sm">
            {data.symbol} • {data.sector}
          </Text>
        </Box>
      </Flex>
      
      <Flex
        align={{ base: 'flex-start', md: 'flex-end' }}
        direction="column"
      >
        <PriceDisplay
          change={data.change}
          changePercent={data.changePercent}
          price={data.price}
          symbol={data.symbol}
        />
        
        <Flex justify="flex-end" mt={2} width="100%">
          <RefreshButton
            isRefreshing={isRefreshing}
            onRefresh={onRefresh}
          />
        </Flex>
      </Flex>
    </Flex>
    
    <Text fontSize="sm" noOfLines={3}>
      {data.description}
    </Text>
  </Box>
)

export default StockHeader
